(() => {
  const hero = document.querySelector('.category-hero');
  const ribbon = document.querySelector('.category-ribbon');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let preference = 'auto';
  try { preference = localStorage.getItem('truecut-motion') || 'auto'; } catch {}
  let enabled = false, frame = 0;
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'motion-toggle';
  document.body.append(toggle);
  const clamp = value => Math.max(0, Math.min(1, value));
  function render() {
    frame = 0;
    if (!enabled) return;
    const rect = hero.getBoundingClientRect();
    const ribbonRect = ribbon.getBoundingClientRect();
    const progress = clamp(-rect.top / rect.height);
    hero.style.setProperty('--product-y', (progress * -55).toFixed(2) + 'px');
    hero.style.setProperty('--product-turn', (-5 + progress * 11).toFixed(2) + 'deg');
    hero.style.setProperty('--ring-turn', (progress * 100).toFixed(2) + 'deg');
    ribbon.style.setProperty('--ribbon-x', (-clamp((innerHeight - ribbonRect.top) / (innerHeight + ribbonRect.height)) * 180).toFixed(2) + 'px');
  }
  function schedule() { if (enabled && !frame) frame = requestAnimationFrame(render); }
  function sync() {
    enabled = preference !== 'off' && (!reduced.matches || preference === 'on');
    document.documentElement.classList.toggle('motion-enabled', enabled);
    toggle.textContent = enabled ? 'Ⅱ  Pause motion' : '▷  Enable motion';
    toggle.setAttribute('aria-label', enabled ? 'Pause scroll motion' : 'Enable scroll motion');
    toggle.setAttribute('aria-pressed', String(!enabled));
    if (!enabled && frame) { cancelAnimationFrame(frame); frame = 0; }
    schedule();
  }
  toggle.addEventListener('click', () => {
    preference = enabled ? 'off' : 'on';
    try { localStorage.setItem('truecut-motion', preference); } catch {}
    sync();
  });
  reduced.addEventListener('change', sync);
  window.addEventListener('scroll', schedule, { passive:true });
  window.addEventListener('resize', schedule, { passive:true });
  window.addEventListener('pageshow', sync);
  document.fonts?.ready.then(schedule);
  window.addEventListener('pagehide', () => { if (frame) cancelAnimationFrame(frame); frame = 0; });
  sync();
})();
